// Utilidad para formatear descripciones con saltos de línea y HTML
export const formatDescription = (description) => {
  if (!description) return '';
  
  // Reemplazar diferentes tipos de saltos de línea
  return description
    .replace(/\\n/g, '\n')  // Reemplazar \n literales
    .replace(/\r\n/g, '\n') // Reemplazar \r\n
    .replace(/\r/g, '\n')   // Reemplazar \r
    .trim();
};

// Utilidad para procesar HTML y newlines
export const processHtmlDescription = (description) => {
  if (!description) return '';
  
  // Primero procesar los saltos de línea escapados
  let processed = description
    .replace(/\\n/g, '\n')  // Convertir \n literales a saltos reales
    .replace(/\r\n/g, '\n') // Normalizar \r\n
    .replace(/\r/g, '\n')   // Normalizar \r
    .trim();
  
  // Convertir saltos de línea a <br> para HTML
  processed = processed.replace(/\n/g, '<br>');
  
  return processed;
};

// Componente React para mostrar descripción formateada (texto plano)
export const FormattedDescription = ({ description, maxLines = null, className = '' }) => {
  const formattedText = formatDescription(description);
  
  if (!formattedText) return null;
  
  const lines = formattedText.split('\n');
  const displayLines = maxLines ? lines.slice(0, maxLines) : lines;
  const hasMore = maxLines && lines.length > maxLines;
  
  return (
    <div className={className}>
      {displayLines.map((line, index) => (
        <div key={index}>
          {line || <br />}
        </div>
      ))}
      {hasMore && (
        <div className="text-muted">
          <small>... y {lines.length - maxLines} líneas más</small>
        </div>
      )}
    </div>
  );
};

// Componente React para mostrar descripción con HTML renderizado
export const HtmlFormattedDescription = ({ description, className = '' }) => {
  if (!description) return null;
  
  // Renderizar HTML directamente sin procesar (ya viene formateado)
  return (
    <div 
      className={className}
      dangerouslySetInnerHTML={{ __html: description }}
      style={{ lineHeight: '1.6' }}
    />
  );
};
